import { registerGroup } from '@visactor/vrender-kits/register/register-group';
import { registerSymbol } from '@visactor/vrender-kits/register/register-symbol';

export function loadWeatherComponent() {
  registerGroup();
  registerSymbol();
}
